import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationPackageViewModel, PackageRequirement, ConferenceViewModel, MemberLookupResult, CourseEventViewModel, PurchasePackageFromPOViewModel, BasicEventViewModel, SurveyViewModel } from 'src/app/_models/generatedModels';
import { NgForm } from '@angular/forms';
import { ConferenceCMSService, ConferenceSurveyService, EventService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import Enumerable from 'linq';
import { MemberLookupModalComponent } from './member-lookup-modal.component';
import { EventDetailsFlyoutComponent } from '../page/elements/conference-schedule/event-details-flyout.component';
import { NavigationService } from 'src/app/_services/navigation-service';
import { RegistrationHelperService } from 'src/app/_services/registration-helper.service';
import { ConferenceGroupDiscountsModalComponent } from './conference-group-discounts-modal.component';
import { cloneDeep } from 'lodash';
import { Model } from 'survey-core';


@Component({
  selector: 'bxl-group-registration-registrant-modal',
  templateUrl: 'group-registration-registrant-modal.component.html',
})

export class GroupRegistrationRegistrantModalComponent implements OnInit {
  initialized = false;
  public showWorkshops: boolean;
  submitComplete: Promise<{}> | undefined;

  @ViewChild('theForm', {static: false}) public userFrm: NgForm;
  public errorMessage: string;
  public actualPrice: number;
  PackageRequirement = PackageRequirement;
  reservedBreakouts: number[] = null;
  startTimes: any[] = [];
  registrantPurchase: PurchasePackageFromPOViewModel;
  packages: RegistrationPackageViewModel[];
  selectedPackage: RegistrationPackageViewModel;
  packageChanging: boolean = false;
  currencyCode: string;
  anyPackageHasGroupDiscounts: boolean = false;
  isExistingRecord: boolean = false;
  toggleEventAddOnOptions: boolean = false;
  survey: SurveyViewModel;
  surveyModel: Model;
  existingPackageSurveyId: number = null;

  @Input() conference: ConferenceViewModel;
  @Input() rowNumber: number | null;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, public navigationService: NavigationService, private router: Router, private route: ActivatedRoute, private registrationHelperService: RegistrationHelperService,
    private cmsService: ConferenceCMSService, private eventService: EventService, private toaster: ToasterService, private surveyService: ConferenceSurveyService) {}

  ngOnInit(): void {
    this.cmsService.getPackagesForGroupRegistration(this.conference.id, this.registrationHelperService.conferencePurchaseOrderId || '').subscribe((packages) => {
      this.packages = Enumerable.from(packages)
        .orderBy((x) => x.category)
        .thenBy((x) => x.order)
        .toArray();
      
      this.anyPackageHasGroupDiscounts = this.packages.some(x => x.hasGroupDiscounts === true);

      if (this.rowNumber) {
        this.registrantPurchase = cloneDeep(this.registrationHelperService.getRegistrantPurchase(this.rowNumber));
        this.packageChanged(true);
      } else {
        this.registrantPurchase = new PurchasePackageFromPOViewModel();
        this.registrantPurchase.package = null;
        this.registrantPurchase.tempRowNumber = this.registrationHelperService.getNextRowNumber();
      }
      
      this.isExistingRecord = this.registrationHelperService.conferencePurchaseOrderId != null && this.registrantPurchase.userId != null;
      this.currencyCode = this.registrationHelperService.currencyCode;
      this.initialized = true;
    });
  }

  packageChanged(isOnLoad: boolean = false) {
    this.packageChanging = true;
    this.cmsService.getSingleRegistrationPackageForGroupRegistration(this.conference.id.toString(), this.registrantPurchase.package?.id, this.registrationHelperService.conferencePurchaseOrderId || '').subscribe((pkg) => {
      this.selectedPackage = pkg;
      this.toggleEventAddOnOptions = this.selectedPackage.eventAddons && this.selectedPackage.eventAddons.length > 5;

      if (isOnLoad) {
        // since control is bound to complex object, we have to do this step to select the package on load
        this.registrantPurchase.package = this.packages.find(x => x.id === this.registrantPurchase.package?.id);
        this.existingPackageSurveyId = this.selectedPackage.customQuestionSurveyId;
      }

      // try and match up the add-ons and event add-ons that were previously selected
      this.selectedPackage.addOns.forEach((x) => {
        x.selected = this.registrantPurchase.selectedAddOns?.findIndex((y) => y.id == x.id) > -1;
      });
      this.selectedPackage.eventAddons.forEach((x) => {
        x.selected = this.registrantPurchase.selectedEventAddons?.findIndex((y) => y.id == x.id) > -1;
      });
      if (this.registrantPurchase.selectedEventAddons?.length > 0) {
        this.showWorkshops = true;
      }

      if (this.selectedPackage.reserveBreakouts) {
        this.startTimes = Enumerable.from(this.selectedPackage.courseEvents)
          .where((x) => x.currentBreakoutCount < x.breakoutCapacity)
          .orderBy((x) => x.startTime)
          .groupBy((x) => x.formattedFullTime)
          .where((x) => x.getSource().length > 1)
          .toArray();
        this.reservedBreakouts = new Array<number>(this.startTimes.length);

        for (var i = 0; i < this.startTimes.length; i++) {
          for (var j = 0; j < this.registrantPurchase.reservedBreakouts?.length; j++) {
            var item: BasicEventViewModel[] = <BasicEventViewModel[]>(<unknown>this.startTimes[i].getSource());
            var ids = Enumerable.from(item)
              .select((x) => x.id)
              .toArray();

            if (ids.indexOf(this.registrantPurchase.reservedBreakouts && this.registrantPurchase.reservedBreakouts[j]) > -1) {
              this.reservedBreakouts[i] = this.registrantPurchase.reservedBreakouts[j];
            }
          }
        }
      } else {
        this.registrantPurchase.reservedBreakouts = [];
        this.reservedBreakouts = [];
      }

      // handle custom survey and try to use existing data if it's the same survey
      if (this.selectedPackage.customQuestionSurveyId) {
        this.loadSurveyAndSetData();
      } else {
        this.registrantPurchase.customSurveyJSON = null;
        this.existingPackageSurveyId = this.selectedPackage.customQuestionSurveyId;
      }
      


      this.calculatePrice();
      this.packageChanging = false;
    });
  }

  loadSurveyAndSetData() {
    this.surveyService.getSurveyById(this.conference.organizationId.toString(), this.conference.id, this.selectedPackage.customQuestionSurveyId).subscribe((result) => {
      this.survey = result;
      const survey = new Model(JSON.parse(result.schemaJSON));
      this.surveyModel = survey;
      this.surveyModel.isSinglePage = true;
      this.surveyModel.showNavigationButtons = false;
      this.surveyModel.showQuestionNumbers = false;
      this.surveyModel.questionsOnPageMode = 'singlePage';
      this.surveyModel.focusFirstQuestionAutomatic = false;
      this.surveyModel.mode = 'edit';

      if (this.registrantPurchase.customSurveyJSON && this.existingPackageSurveyId == this.selectedPackage.customQuestionSurveyId) {
        this.surveyModel.data = JSON.parse(this.registrantPurchase.customSurveyJSON || '{}');
      } else {
        this.registrantPurchase.customSurveyJSON = null;
      }
      this.existingPackageSurveyId = this.selectedPackage.customQuestionSurveyId;

      this.initialized = true;
    });
  }

  checkMembership() {
    const modalRef = this.modalService.open(MemberLookupModalComponent, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static'
    });
    modalRef.componentInstance.conference = this.conference;
    modalRef.componentInstance.pckg = this.selectedPackage;
    modalRef.componentInstance.organizationName = this.conference.organization.shortName;

    modalRef.result.then(
      (result: MemberLookupResult) => {
        this.registrantPurchase.memberLookupResult = result;
        this.calculatePrice();
      },
      (reason) => {}
    );
    return;
  }

  addRegistrantClicked() {
    if (this.selectedPackage.requirement.toString() == PackageRequirement[PackageRequirement.EDUAddress].toString() && this.registrantPurchase.email.indexOf('.edu') == -1) {
      this.errorMessage = 'You must register with an .edu email address to purchase a student package.';
      return;
    }

    if (this.registrationHelperService.isEmailDuplicate(this.registrantPurchase.email, this.registrantPurchase.tempRowNumber)) {
      this.errorMessage = 'This email address is already used for another registrant on this PO.';
      return;
    }

    if (this.surveyModel?.hasErrors() || !this.userFrm.valid) {
      this.markAllTouched();
      this.errorMessage = 'There are some invalid or missing fields. Please fill out all required fields.';
      return;
    }

    this.errorMessage = '';

    this.registrantPurchase.selectedAddOns = Enumerable.from(this.selectedPackage.addOns)
      .where((x) => x.selected)
      .toArray();
    this.registrantPurchase.selectedEventAddons = Enumerable.from(this.selectedPackage.eventAddons)
      .where((x) => x.selected)
      .toArray();
   
    if (this.isExistingRecord) {
      // don't change reservations unless package was changed and doesn't have reserveBreakouts
      if (!this.selectedPackage.reserveBreakouts) {
        this.registrantPurchase.reservedBreakouts = [];
      }
    } else {
      this.registrantPurchase.reservedBreakouts = this.reservedBreakouts;
    }

    if (!this.selectedPackage.customQuestionSurveyId) {
      this.registrantPurchase.customSurveyJSON = null;
    } else {
      this.registrantPurchase.customSurveyJSON = JSON.stringify(this.surveyModel?.data);
    }
    
    if (!this.selectedPackage.memberPricing) {
      this.registrantPurchase.isMember = false;
      this.registrantPurchase.memberLookupResult = null;
    }

    if (this.rowNumber) {
      this.registrationHelperService.updateRegistrantPurchase(this.registrantPurchase);
    } else {
      this.registrationHelperService.addRegistrantPurchase(this.registrantPurchase);
    }
    
    this.activeModal.close();
  }

  markAllTouched() {
    Object.keys(this.userFrm.controls).forEach((field) => {
      // {1}
      const control = this.userFrm.control.get(field);
      control.markAsTouched({onlySelf: true});
      control.markAsDirty({onlySelf: true}); // {3}
    });
  }

  showDetails(evt: CourseEventViewModel) {
    const modalRef = this.modalService.open(EventDetailsFlyoutComponent, {
      size: 'lg',
      keyboard: false,
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'flyout',
      backdropClass: 'flyout',
      backdrop: 'static'
    });
    modalRef.componentInstance.event = evt;
    modalRef.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  calculatePrice() {
    if (this.registrantPurchase.memberLookupResult?.success) {
      this.registrantPurchase.isMember = true;
    }

    var chargeForCEUs = this.registrantPurchase.purchaseCEUs && !this.registrantPurchase.registrantPurchasedCEUsSeparately;
    this.actualPrice = this.registrationHelperService.calculateRegistrantPrice(this.selectedPackage, this.registrantPurchase.isMember, chargeForCEUs, this.registrantPurchase.memberLookupResult, 0, 0);

    //in case add-on or event add-on selection was changed, save off those changes
    this.registrantPurchase.selectedAddOns = Enumerable.from(this.selectedPackage?.addOns)
        .where((x) => x.selected)
        .toArray();
      this.registrantPurchase.selectedEventAddons = Enumerable.from(this.selectedPackage?.eventAddons)
        .where((x) => x.selected)
        .toArray();
  }

  breakoutChanged() {
    this.registrantPurchase.reservedBreakouts = this.reservedBreakouts;
  }

  openGroupDiscountDetails() {
      const modalRef = this.modalService.open(ConferenceGroupDiscountsModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
        modalRef.componentInstance.conferenceId = this.conference.id;
        modalRef.componentInstance.conferencePurchaseOrderId = this.registrationHelperService.conferencePurchaseOrderId;
        modalRef.result.then(
          (result) => {},
          (reason) => {}
        );
    }
}
